import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Discussion Point'}
      url={'dtpDiscussionPoints'}
      queryKey="dtpDiscussionPoints"
      title={'Discussion Point'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
